import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label }) => (
  <div className="flex items-center gap-4" data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <span className="font-display text-sm italic text-[#C48B71]">( {num} )</span>
    <span className="h-px w-10 bg-[#C48B71]/50" />
    <span className="overline-label">{label}</span>
  </div>
);
